import $ from 'jquery';
import { BaseController } from '../core/BaseController';
import CartView from '../views/CartView';
import CartService from '../services/CartService';
import CartModel from '../models/CartModel';

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
const SELECTORS = {};

/**
 * Cart Controller
 *
 * @class CartController
 * @constructor
 */
export default class CartController extends BaseController {
    constructor($element) {
        super();
        this.init($element);
    }

    /**
     * Initializes methods
     *
     * @method init
     * @public
     * @chainable
     */
    init($element) {
        /**
         * A reference to the containing DOM $element
         *
         * @property $element
         * @type {type}
         * @public
         */
        this.$element = $element;

        return this.setupHandlers()
            .createChildren()
            .layout()
            .enable();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */
    setupHandlers() {

        return this;
    }

    /**
     * createChildren
     *
     * @method createChildren
     * @public
     * @chainable
     */
    createChildren() {
        this.cartModel = new CartModel();
        this.cartService = new CartService();
        this.view = new CartView(this.$element, this);
        return this;
    }

    /**
     * Layout
     *
     * @method layout
     * @public
     * @chainable
     */
    layout() {

        return this;
    }

    /**
     * Enable
     *
     * @method enable
     * @public
     * @chainable
     */
    enable() {

        return this;
    }

    /**
     * Disable
     *
     * @method disable
     * @public
     * @chainable
     */
    disable() {

        return this;
    }
}